import { ProgressIndicator } from "@fluentui/react";
import React from "react";
import { Stack, Text } from "sprint-common-web";

import { OrderProgressData } from "../../utils/calculateOrderProgress";

type OrderCompletionProgressInfoProps = {
    text?: string;
    progress: OrderProgressData;
    testId?: string;
};
export const OrderCompletionProgressInfo = (props: OrderCompletionProgressInfoProps): JSX.Element => {
    const { text, progress } = props;
    return (
        <Stack styles={{ root: { width: 100 } }} data-testId={props.testId}>
            <Text variant="smallPlus">
                {text ? `${text}: ` : ""}
                {progress.completed}/{progress.total}
            </Text>
            <ProgressIndicator barHeight={2} percentComplete={progress.percentage} />
        </Stack>
    );
};
